import type { OnOpenChangeData, OpenPopoverEvents } from '@fluentui/react-components';
import { useCallback, useState } from 'react';

export function useOpenPopover() {
    const [open, setOpen] = useState(false);

    const openPopover = useCallback(() => setOpen(true), []);
    const closePopover = useCallback(() => setOpen(false), []);
    const onOpenChange = useCallback((event: OpenPopoverEvents, data: OnOpenChangeData) => {
        // NOTE: This check is required to prevent the popover from closing when
        // the user uses the spacebar key in one of the filter inputs.
        if (event.isTrusted) {
            setOpen(data.open);
        }
    }, []);

    return {
        open,
        openPopover,
        closePopover,
        onOpenChange,
    };
}
